import { useEffect, useRef, useState } from "react";
import { supabase } from "../supabaseClient";
import { isGodModeEmail } from "../utils/tradieWorkspace";

// Security: is_god_mode checks the signed-in Supabase Auth email server-side.
// The email fallback keeps the Settings tab visible if the live DB migration
// has not been applied yet. Server-side policies still gate privileged DB work.
export function useGodMode() {
  const [isGodMode, setIsGodMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const checked = useRef(false);

  useEffect(() => {
    // Only call once per session — result is stable for the lifetime of the tab.
    if (checked.current) return;
    checked.current = true;

    supabase
      .rpc("is_god_mode")
      .then(async ({ data, error }) => {
        if (!error && data === true) {
          setIsGodMode(true);
        } else {
          const { data: userData } = await supabase.auth.getUser();
          setIsGodMode(isGodModeEmail(userData?.user?.email));
        }
        setLoading(false);
      })
      .catch(async () => {
        const { data: userData } = await supabase.auth.getUser();
        setIsGodMode(isGodModeEmail(userData?.user?.email));
        setLoading(false);
      });
  }, []);

  return { isGodMode, loading };
}
